import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52119f18"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" (조합원 자격) ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 주당 가격 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 판매 금액 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" MY ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bar" }, "|", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ag_intersect_box = _resolveComponent("ag-intersect-box")!

  return (_openBlock(), _createBlock(_component_ag_intersect_box, { css: {height: 160} }, {
    default: _withCtx(() => [
      _createVNode(_component_ag_box_s, { css: {dp: 'flex', borderBottom: '1px solid #F9F9FB', pt: '16px', pb: '20px'} }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_img, {
            width: "44px",
            height: "44px",
            style: {"flex-shrink":"0"},
            src: _ctx.stakeInfoRef.partnershipLogo
          }, null, 8, ["src"]),
          _createVNode(_component_ag_box_s, { css: {pl: '14px', width: '100%'} }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_text_s, { css: {typography: 'list17m', dp: 'block', mb: '4px', pl: '2px'} }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.stakeInfoRef.partnershipName) + " ", 1),
                  _createVNode(_component_ag_text_s, { css: {typography: 'main16r', color: 'gray2'} }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box_s, { css: {dp: 'flex', width: '100%', justifyContent: 'space-between', mb: '4px'} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_text_s, { css: {typography: 'main13r', color: 'gray3'} }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_box_s, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ag_text_s, { css: {typography: 'num16bk'} }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.currency(_ctx.stakeInfoRef.price)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ag_text_s, { css: {typography: 'main16r'} }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box_s, { css: {dp: 'flex', justifyContent: 'space-between', mb: '8px', width: '100%'} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_text_s, { css: {typography: 'main13r', color: 'gray3'} }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_box_s, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ag_text_s, { css: {typography: 'main13r'} }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.currency(_ctx.stakeInfoRef.totalPrice)) + " 원 ", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ag_text_s, { css: {color: 'gray3', typography: 'main13r'} }, {
                        default: _withCtx(() => [
                          _createTextVNode(" (약 " + _toDisplayString(_ctx.$filters.currency(_ctx.stakeInfoRef.qty)) + " 주) ", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box_s, { css: {dp: 'flex', alignItems: 'center'} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.personCircleOutline,
                    style: {"color":"#D4D9DF","width":"20px","height":"20px","margin-right":"3px"}
                  }, null, 8, ["icon"]),
                  (!_ctx.stakeInfoRef.mine)
                    ? (_openBlock(), _createBlock(_component_ag_text_s, {
                        key: 0,
                        css: {typography: 'main13r', color: 'gray3', dp: 'block'}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.stakeInfoRef.publicId), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_ag_text_s, {
                        key: 1,
                        css: {typography:'text13r', color: 'primary'}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })),
                  _createVNode(_component_ag_text_s, { css: {typography: 'main13r', color: 'gray3', height: 20} }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createTextVNode(" " + _toDisplayString(_ctx.prettyDateToOnemonth(_ctx.stakeInfoRef.createAt)) + " 등록 ", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}